export default "__VITE_ASSET__BtxhMPtL__"